module.exports = __webpack_public_path__ + "static/media/STARS.3bd9df02.png";